import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import anime from 'animejs/lib/anime.es.js';
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import Choices from 'choices.js';
import "choices.js/public/assets/styles/choices.css";

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

window.Swiper = Swiper;
window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.Choices = Choices;

function headingReveal() {
    Splitting({
        /* target: String selector, Element, Array of Elements, or NodeLis */
        target: ".page-heading",
        /* by: String of the plugin name */
        by: "words",
        /* key: Optional String to prefix the CSS variables */
        key: null
      });
    anime({
        targets: '.words. word',
        translateY: [60 + (window.innerWidth*.025),0],
        loop: 0,
        delay: anime.stagger(100),
        easing: 'cubicBezier(0.84,0.11,0.2,0.87)'
    });
}

function animateSVGFill(svgElement, offset, duration) {

    if(!offset) {
        offset = 0;
    }

    if (!duration) {
        duration = 500;
    }

    anime({
        targets: svgElement.querySelector('path'),
        strokeDashoffset: [anime.setDashoffset, offset],
        easing: 'linear',
        duration: duration,
        delay: function (el, i) { return i * 250 },
        direction: 'alternate',
        loop: false,
        complete: function(anim) {
            svgElement.classList.add('!fill-current');
        },
    });
}

function animateSVGStroke(svgElement, offset, duration) {

    if(!offset) {
        offset = 0;
    }

    if (!duration) {
        duration = 500;
    }

    anime({
        targets: svgElement.querySelector('path'),
        strokeDashoffset: [anime.setDashoffset, offset],
        easing: 'linear',
        duration: duration,
        delay: function (el, i) { return i * 250 },
        direction: 'alternate',
        loop: false
    });
}

function playVideo(element) {
    const videoContainer = element.closest('.video-container');
    const videoID = videoContainer.getAttribute('data-video-id');

    const iframeHTML = '<iframe class="transition-all delay-300 duration-300 absolute z-[2] opacity-0 left-0 top-0 w-full h-full scale-[1.01] origin-center" src="https://player.vimeo.com/video/' + videoID + '?autoplay=1&quality=1080p" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';

    videoContainer.insertAdjacentHTML('beforeend', iframeHTML);

    videoContainer.classList.add('playing');
}

function loadForms(){
    if (!window.formcontact_us) {
        window.formcontact_us = function () {
            let form = document.getElementById("contact_us");
            form.noValidate = true;
            const visited = [];

            for (const field of form.elements) {
                field.addEventListener("invalid", function handleInvalidField(event) {
                  setFieldValidity(field)
                  event.preventDefault();
                });

                field.addEventListener("blur", function handleFieldBlur() {
                  if (!visited.includes(field)) {
                    visited.push(field);
                  }
                  field.checkValidity();
                });

                field.addEventListener("input", function handleFieldInput(event) {
                    // if (!visited.includes(field)) return;
                    // console.log(field);
                    setFieldValidity(field)
                  });
            }

            function errorContainer(field) {
                const errorContainerId = field
                  .getAttribute("aria-describedby")
                  .split(" ")
                  .find((id) => id.includes("error"));
                // console.log(errorContainerId);
                return document.getElementById(errorContainerId);
            }

            function setFieldValidity(field) {
                  if (!field.validity.valid) {
                      errorContainer(field).textContent = field.validationMessage;
                  field.setAttribute("aria-invalid", "true");
                } else {
                      errorContainer(field).textContent = "";
                  field.removeAttribute("aria-invalid");
                }
            }

            function sendToHubSpot(formData) {

                let fields = [];
                let subscribe = false;

                for(var key in formData) {
                    if(key != '_token' && key != 'subscribe') {
                        var field = {
                            "objectTypeId": "0-1",
                            "name" : key,
                            "value" : formData[key]
                        }
    
                        fields.push(field);
                    }

                    if(key == 'subscribe' && formData[key] == true) {
                        subscribe = true;
                    }
                }

                let postData = {
                    "fields": fields,
                    "legalConsentOptions": {
                        "consent": {
                            "consentToProcess": true,
                            "text": "I agree to allow Cicada to store and process my personal data.",
                            "communications": [
                                {
                                    "value": subscribe,
                                    "subscriptionTypeId": 12134030,
                                    "text": "Keep me updated of Cicada events, programs & opportunities"
                                }
                            ]
                        }
                    }
                }


                var xhr = new XMLHttpRequest();
                var url = 'https://api.hsforms.com/submissions/v3/integration/submit/8329006/907950a4-a50b-4613-bbaf-c762b7f005be'


                var final_data = JSON.stringify(postData)

                console.log('finaldata');
                console.log(final_data);

                xhr.open('POST', url);
                xhr.setRequestHeader('Content-Type', 'application/json');

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        console.log(xhr.responseText); // Returns a 200 response if the submission is successful.
                    } else if (xhr.readyState == 4 && xhr.status == 400) {
                        console.log(xhr.responseText); // Returns a 400 error the submission is rejected.          
                    } else if (xhr.readyState == 4 && xhr.status == 403) {
                        console.log(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.           
                    } else if (xhr.readyState == 4 && xhr.status == 404) {
                        console.log(xhr.responseText); //Returns a 404 error if the formGuid isn't found     
                    }
                }

                xhr.send(final_data)
            }

            return {
                formData: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone_number: '',
                    subject: '',
                    subscribe: '',
                    _token: document.querySelector('input[name="_token"]').value,
                },
                loading: false,
                error_message: false,
                success_message: false,
                buttonLabel: 'Submit',

                submitData(e) {
                    const isValid = form.reportValidity();

                    this.buttonLabel = 'Submitting...'
                    this.loading = true;
                    this.error_message = false;
                    this.success_message = false;

                    if (isValid) {
                       fetch('/!/forms/contact_us', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(this.formData),
                        })
                        .then((data) => {
                            console.log(data);
                            this.success_message = true;

                            setTimeout(() => { form.classList.add('h-0') }, 500);
                        })
                        .catch((err) => {
                            console.log(err);
                            this.error_message = true;
                            this.loading = false;
                        })
                        .finally(() => {
                            this.loading = false;
                            sendToHubSpot(this.formData);
                            form.scrollIntoView({
                                behavior: 'smooth'
                            });
                        })
                    } else {
                        this.buttonLabel = 'Submit';
                        this.loading = false;
                    }

                    e.preventDefault();

                }

            }
        }
    }
}

Alpine.data('caseStudySwiper', () => ({
    swiper: null,
    init() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 1.2,
            spaceBetween: 40,
            breakpoints: {
                1200: {
                    slidesPerView: 1.2,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 0.9,
                    spaceBetween: 20
                }
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    }
}));

Alpine.data('imageTextCarousel', () => ({
    swiper: null,
    init() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    }
}));

Alpine.data('twoColTextCarousel', () => ({
    swiper: null,
    init() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 1,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true
            }
        });
    }
}));

Alpine.data('timelineSwiper', () => ({
    swiper: null,
    totalCardsWidth: 0,

    init() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 1.5,
            spaceBetween: 20,
            centeredSlides: false,
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                1024: {
                    slidesPerView: 3.3,
                    spaceBetween: 20,
                    centeredSlides: false,
                    pagination: {
                        el: null // Disable pagination on desktop
                    }
                }
            }
        });
        
        const calculateTotalWidth = () => {
            const slides = this.swiper.slides;
            const totalWidth = slides.reduce((acc, slide) => {
                return acc + slide.offsetWidth + 20; // Add spaceBetween value
            }, 0);
            this.totalCardsWidth = totalWidth + 50;
        };

        this.$nextTick(() => {
            calculateTotalWidth();
        })


        window.addEventListener('resize', () => {
            calculateTotalWidth();
        });
    }
}));

Alpine.data('galleryLightbox', () => ({
    gallery: null,
    
    init() {
        let leftArrowSVGString = '<svg viewBox="276.432 136.388 28.774 56.56" width="28.774" height="56.56" xmlns="http://www.w3.org/2000/svg"><path d="m277.42 192.948 27.786-28.774-28.774-27.786" stroke="#000" stroke-width="6" fill="none" stroke-linejoin="bevel" style="transform-origin:290.819px 164.668px" transform="rotate(180 0 0)"/></svg>';
        let rightArrowSVGString = '<svg width="34" height="62" xmlns="http://www.w3.org/2000/svg"><path d="M3.494 59.28 31.28 30.506 2.506 2.72" stroke="#000" stroke-width="6" fill="none" fill-rule="evenodd" stroke-linejoin="bevel"/></svg>';
        let closeSVGString = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class=""><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>';
        this.gallery = new PhotoSwipeLightbox({
            gallery: this.$el.querySelector('.lightbox-gallery'),
            children: '.pswp-gallery__item',
            pswpModule: () => import('photoswipe'),

            mainClass: 'pswp--custom-icon-colors',

            maxSpreadZoom: 1,
            secondaryZoomLevel: (zoomLevelObject) => {
                return 'fit';
            },
            padding: { top: 100, bottom: 100, left: 100, right: 100 },
            counter: false,
            zoom: false,

            arrowPrevSVG: leftArrowSVGString,
            arrowNextSVG: rightArrowSVGString,
            closeSVG: closeSVGString,

        });

          this.gallery.on('contentActivate', (e) => {
            const { content } = e;
            if(content){
              const wrapperDiv = document.createElement('div');
              wrapperDiv.className = 'pswp__img_wrapper';
              wrapperDiv.style.width = content.displayedImageWidth + 'px';
              wrapperDiv.style.height = content.displayedImageHeight + 'px';
              wrapperDiv.style.position = 'relative';
              content.slide.container.prepend(wrapperDiv);

              if(content.element.alt){
                const captionDiv = document.createElement('div');
                captionDiv.className = 'pswp__img_caption';
                captionDiv.innerText = content.element.alt;
                content.slide.container.querySelector('.pswp__img_wrapper').appendChild(captionDiv);
              }

              setTimeout(() => {
                content.slide.container.querySelector('.pswp__img_wrapper').classList.add('active');
              }, 500);
            }
        });

        this.gallery.init();
    }
}));

window.Alpine = Alpine;
window.playVideo = playVideo;

window.headingReveal = headingReveal;
window.animateSVGStroke = animateSVGStroke;
window.animateSVGFill = animateSVGFill;
loadForms();

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();
